var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 268,
    viewBox: "0 0 343 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 268,
    fill: "#3098F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    width: 49.98,
    height: 268,
    fill: "#082C4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9805,
    width: 49,
    height: 268,
    fill: "#FFCC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.98 0H197.96V268H147.98V0Z",
    fill: "#FE6571"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 197.957,
    width: 28.42,
    height: 268,
    fill: "#F2EAE2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 226.379,
    width: 29.4,
    height: 268,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 255.781,
    width: 29.4,
    height: 268,
    fill: "#D9D9DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 285.18,
    width: 28.42,
    height: 268,
    fill: "#747481"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 313.598,
    width: 29.4,
    height: 268,
    fill: "#05051E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorMobile);
export default __webpack_public_path__ + "static/media/color-mobile.c8dadf9e25af0ae4541416244758789e.svg";
export { ForwardRef as ReactComponent };